import { formattedTokenCost } from 'utils/common';
import { ASSET_PREFIX } from 'utils/constants';
import styles from './PurchaseTokensBanner.module.css';

interface PurchaseTokensBannerProps {
  tokenCount: number;
}

/** A banner that shows the number of tokens someone has. Previously, it also started the purchase tokens flow */
const PurchaseTokensBanner = ({ tokenCount }: PurchaseTokensBannerProps) => {
  return (
    <section className={styles.container}>
      <img
        className={styles.icon}
        src={`${ASSET_PREFIX}/images/token-town/arcade-gold-token.svg`}
        alt=""
      />
      <p className={styles.bannerText}>
        You have {formattedTokenCost(tokenCount)} <br />
      </p>
      <img
        className={styles.icon}
        src={`${ASSET_PREFIX}/images/token-town/arcade-gold-token.svg`}
        alt=""
      />
    </section>
  );
};

export default PurchaseTokensBanner;
